<script lang="ts">
import { navigate } from "svelte-navigator";
import { Alert } from "sveltestrap";
import Credentials from "../components/Credentials.svelte";
import { authService, uiService } from "../services";
import { startSession } from "../services/session";


    let email = null;
    let pass = null;
    let showLoginError = false;

    async function login() {
        try {
            const accessToken = await authService.login(email, pass);
            await startSession(accessToken);
            navigate('/');
        } catch (error) {
            console.error(error);
            showLoginError = true;
        }
    }

</script>



<style>

    .body-html {
        height: 100vh;
        display: flex;
        align-items: center;
        padding-top: 40px;
        padding-bottom: 40px;
        background-color: #f5f5f5;
    }

    img{
        width: 100%;
        height: auto;
    }

    .form-signin {
        width: 100%;
        max-width: 360px;
        margin: auto;
    }

    .login-box{
        border: 1px solid darkgray;
        padding: 30px;
        background-color: white;
        border-radius: 5px;
    }

    .form-signin .checkbox {
        font-weight:  400;
    }

    .form-signin .form-floating:focus-within {
        z-index: 2;
    }

    .form-signin input[type="email"] {
        margin-bottom: 10px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        background-color: #f5f5f5;
    }

    .form-signin input[type="password"] {
        margin-bottom: 10px;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        background-color: #f5f5f5;
    }


</style>

<div class="content-html">
    <div class="body-html text-center">
        <div  class="form-signin">
            <form on:submit|preventDefault="{login}">
                <!-- svelte-ignore a11y-missing-attribute -->
                <img class="mb-4" src="/images/logo.png">
                <div class="login-box">
                    <h1 class="h3 mb-3 fw-normal">Bienvenido</h1>
                    <p>Rellene los siguientes campos para poder acceder.</p>
                
                    <div class="form-floating">
                      <input type="email" class="form-control" id="floatingInput" bind:value={email} placeholder="name@example.com">
                      <label for="floatingInput">Usuario</label>
                    </div>
                    <div class="form-floating">
                      <input type="password" class="form-control" id="floatingPassword" bind:value={pass} placeholder="Password">
                      <label for="floatingPassword">Contraseña</label>
                    </div>
                
                    <div class="checkbox mb-3">
                      <!-- <label>
                        <input type="checkbox" value="remember-me"> Remember me
                      </label> -->
                    </div>

                    {#if showLoginError}
                    <Alert>
                        Ha ocurrido un error 
                    </Alert>
                    {/if}

                    <button class="w-100 btn btn-lg btn-primary" type="submit">Entrar</button>
                </div>

                <p class="mt-5 mb-3 text-muted"><Credentials /></p>
              </form>
        </div>
    </div>
        
</div>
